import axios from './axios';


const getCrmCsvFile = async (token, payload) => {

    try {
      const response = await axios.post(`crm/`, payload,  { headers: { Authorization: "Bearer " + token } });
      return { "error": 0, httpCode: response.status, "message": "",  data: response.data ? response.data : [] }
    }
    catch (e) {
      if (e.response) {
        return { "error": 1, httpCode: e.response.status, "message": e.response.data["message"] ? e.response.data["message"] : e.response.data }
      }
    }
  }


  const sendEmail = async (token, payload) => {

    try {
      const response = await axios.post(`crm/sendEmail`, payload,  { headers: { Authorization: "Bearer " + token } });
      return { "error": 0, httpCode: response.status, "message": "",  data: response.data ? response.data : {}}
    }
    catch (e) {
      if (e.response) {
        return { "error": 1, httpCode: e.response.status, "message": e.response.data["message"] ? e.response.data["message"] : e.response.data }
      }
    }
  }
  


 
export { getCrmCsvFile , sendEmail};